// libs
import React from 'react'

import {
  MeetingFragmentFragment
} from '@lopo-tech/lopo-api'

// components
import Modal from 'src/components/modal/modal'

// styles
import { ReportForm } from './report_form'

type Props = {
  meeting: MeetingFragmentFragment;
  closeModal: () => void;
};

export const ProjectCreateReportModal: React.FC<Props> = ({
  meeting,
  closeModal
}) => {
  return (
    <Modal autoSize onClose={closeModal}>
      <ReportForm {...meeting} closeModal={closeModal} />
    </Modal>
  )
}
